export function convertAndAddToObject<T, U, V>(
	obj: T,
	value: U,
	key: keyof T,
	converter: (arg: U) => V
) {
	return {
		...obj,
		[key]: converter(value)
	};
}
